/**
 * Widget subscription: tombol toggle vertikal + popup subscription.
 * Markup dari dufeng_render_subscribe_widget() (includes/helper.php).
 */

var DISMISS_COOKIE = "dufeng_subscribe_popup_dismissed";
var AUTO_OPEN_DELAY = 800;
var BODY_OPEN_CLASS = "subscribe-popup-open";
// Class ini beda dari BODY_OPEN_CLASS: ini bukan status buka/tutup popup,
// tapi penanda "tombol trigger .subscribe-widget__badge ada & aktif di
// halaman ini" - dilepas lagi kalau widgetnya di-dismiss permanen (tombol
// .subscribe-widget__close), bukan cuma saat popup ditutup.
var BODY_BADGE_PRESENT_CLASS = "has-subscribe-widget";

export function initSubscribeWidget() {
  // .subscribe-widget (tombol toggle) & .subscribe-popup sengaja dirender
  // sebagai sibling, bukan nested, supaya popup (fixed, inset:0) tidak ikut
  // containing block/stacking context tombolnya.
  var widget = document.querySelector(".subscribe-widget");
  var popup = document.getElementById("subscribe-popup");
  if (!widget || !popup) return;

  var badge = widget.querySelector(".subscribe-widget__badge");
  var widgetClose = widget.querySelector(".subscribe-widget__close");
  var popupClose = popup.querySelector(".subscribe-popup__close");
  var overlay = popup.querySelector(".subscribe-popup__overlay");
  var skip = popup.querySelector(".subscribe-popup__skip");

  function openPopup() {
    popup.hidden = false;
    popup.setAttribute("aria-hidden", "false");
    if (badge) badge.setAttribute("aria-expanded", "true");
    document.body.classList.add("no-scroll", BODY_OPEN_CLASS);
  }

  function closePopup() {
    popup.hidden = true;
    popup.setAttribute("aria-hidden", "true");
    if (badge) badge.setAttribute("aria-expanded", "false");
    document.body.classList.remove("no-scroll", BODY_OPEN_CLASS);
  }

  // "Not Today": popup tidak auto-tampil lagi selama 24 jam, tapi tetap
  // bisa dibuka manual lewat tombol toggle (lihat cek show-on-load di bawah).
  function dismissForADay() {
    var expires = new Date(Date.now() + 24 * 60 * 60 * 1000).toUTCString();
    document.cookie = DISMISS_COOKIE + "=1; expires=" + expires + "; path=/; SameSite=Lax";
  }

  function isDismissedForADay() {
    return document.cookie.indexOf(DISMISS_COOKIE + "=") !== -1;
  }

  if (badge) {
    document.body.classList.add(BODY_BADGE_PRESENT_CLASS);
    badge.addEventListener("click", openPopup);
  }

  if (widgetClose) {
    widgetClose.addEventListener("click", function () {
      closePopup();
      widget.classList.add("is-dismissed");
      document.body.classList.remove(BODY_BADGE_PRESENT_CLASS);
    });
  }

  if (popupClose) {
    popupClose.addEventListener("click", closePopup);
  }

  if (overlay) {
    overlay.addEventListener("click", closePopup);
  }

  if (skip) {
    skip.addEventListener("click", function () {
      closePopup();
      dismissForADay();
    });
  }

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape" && !popup.hidden) {
      closePopup();
    }
  });

  if (popup.dataset.showOnLoad === "1" && !isDismissedForADay()) {
    window.setTimeout(openPopup, AUTO_OPEN_DELAY);
  }
}
